export default "__VITE_ASSET__BVGZuyjk__"